import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/CloseGeminiThread.graphql';
import { Mutation, MutationcloseGeminiThreadArgs } from '../../__generated__/globalTypes';

export const useCloseGeminiThreadMutation = (
  options?: MutationHookOptions<Mutation, MutationcloseGeminiThreadArgs>
) => {
  const [callCloseGeminiThread, result] = useMutation<Mutation, MutationcloseGeminiThreadArgs>(MUTATION, options);

  return { callCloseGeminiThread, ...result };
};

export type CloseGeminiThreadMutationFunction = Mutation['closeGeminiThread'];
